import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("Signing you in…");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      setStatus("No session found. Returning home…");
      setTimeout(() => navigate("/", { replace: true }), 1200);
      return;
    }

    (async () => {
      try {
        await axios.post(
          `${API}/auth/session-exchange`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        await refresh();
        toast.success("Signed in. Welcome.");
        // Strip hash and go home
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div
      className="min-h-[60vh] flex items-center justify-center"
      data-testid="auth-callback-page"
    >
      <div className="text-center">
        <div className="inline-block w-10 h-10 border-2 border-[#4A6B53] border-t-transparent rounded-full animate-spin mb-5" />
        <p className="font-serif text-xl text-[#2C2A28]">{status}</p>
      </div>
    </div>
  );
}
